




















































import {Component, Vue, Watch} from 'vue-property-decorator'
import usersAApi from '@/api/users-a'
import usersApi from '@/api/users'
import {
    UserAEditDto,
    IUserGeneralAndContactInfoSection,
    IUserAdminRightsSection
} from "@/global";
import * as enums from "@/global-enum";
import appUtils from '@/plugins/app-utils'
import UserGeneralAndContactInfoSection from "@/views/user/UserGeneralAndContactInfoSection.vue";
import UserAdminRightsSection from "@/views/admin-access/UserAdminRightsSection.vue";
import {AuthModule} from "@/store/modules/auth";

@Component({
    components: {
        UserGeneralAndContactInfoSection, UserAdminRightsSection
    }
})
export default class AdminAccess_EditUser extends Vue {
    isLoading = true;
    isButtonsDisabled = false;
    user: UserAEditDto | null = null;

    mounted() {
        const thisInst = this;
        this.initData(() => {
            thisInst.$nextTick(async () => {
                await thisInst.getGeneralAndContactInfoSection().afterDataInit();

                if (thisInst.isAdminWithUsersAccess) {
                    await thisInst.getUserAdminRightsSection().afterDataInit();
                }

                this.isLoading = false;
            });
        });
    }

    getGeneralAndContactInfoSection() {
        return this.$refs.generalAndContactInfoSection as unknown as IUserGeneralAndContactInfoSection;
    }

    getUserAdminRightsSection() {
        return this.$refs.userAdminRightsSection as unknown as IUserAdminRightsSection;
    }

    // computed
    get validateForm(): boolean {
        return !this.veeErrors.any();
    }

    get userFullName(): string {
        return appUtils.getUserFullName(this.user, true);
    }

    get isAdminWithUsersAccess() {
        const userInfo = AuthModule.obtainUserInfo();
        return this.$helpers.isExists(userInfo) &&
            this.$helpers.anyInArray(userInfo!.accesses, x =>
                x.type === enums.UserAccessType_SystemAdmin ||
                x.type === enums.UserAccessType_Users);
    }

    // methods
    validateState(ref: string) {
        return this.$appUtils.vvValidateState(this, ref);
    }

    showError(errorMessage?: string) {
        this.$bvToast.toast(errorMessage || "Спробуйте пізніше", {
            title: "Помилка",
            variant: "danger"
        })
    }

    initData(afterUserInit: () => void) {
        this.isLoading = true;

        if (!this.$helpers.isExists(this.$route.params.id)) return;

        usersAApi.getUserEdit(this.$helpers.toNumeric(this.$route.params.id), ((u) => {
            this.user = u;

            afterUserInit();
        }), this.showError);
    }

    async sendPasswordResetWithConfirm() {
        if (!this.$helpers.isExists(this.user)) return;

        this.$bvModal.msgBoxConfirm(`Ви дійсно хочете відправити на ${this.user!.username} посилання на зміну пароля?`, {
            title: `Зміна пароля`,
            size: 'sm',
            okVariant: 'danger',
            okTitle: 'Відправити',
            cancelTitle: 'Відміна',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
        })
            .then(value => {
                if (value) {
                    this.sendPasswordReset()
                }
            })
    }

    async sendPasswordReset() {
        this.isButtonsDisabled = true;

        if (this.$helpers.isExists(this.user) && this.$helpers.isNotEmpty(this.user!.username)) {
            usersApi.sendPasswordReset(this.user!.username, data => {
                if (data.success) {
                    this.$bvToast.toast("Посилання на зміну пароля успішно відправлено на пошту", {
                        title: "Успіх",
                        variant: "success"
                    });
                } else {
                    this.$bvToast.toast("Посилання на зміну пароля не вдалося відправити", {
                        title: "Помилка",
                        variant: "danger"
                    });
                }

                this.isButtonsDisabled = false;
            }, errorMessage => {
                this.isButtonsDisabled = false;

                this.showError(errorMessage);
            });
        } else {
            this.isButtonsDisabled = false;

            this.showError("Посилання на зміну пароля не вдалося відправити, невідома помилка");
        }
    }

    disableEnableUserWithConfirm() {
        if (!this.$helpers.isExists(this.user)) return;

        this.$bvModal.msgBoxConfirm(`Ви дійсно хочете ${this.user!.isDisabled ? 'включити' : 'відключити'} ${this.userFullName}?`, {
            title: `${this.user!.isDisabled ? 'Включити' : 'Відключити'} абонента`,
            size: 'sm',
            okVariant: 'danger',
            okTitle: this.user!.isDisabled ? 'Включити' : 'Відключити',
            cancelTitle: 'Відміна',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
        })
            .then(value => {
                if (value) {
                    this.disableEnableUser()
                }
            })
            .catch(err => {
                // An error occurred
            })
    }

    disableEnableUser() {
        this.isButtonsDisabled = true;

        let newIsDisabled =  !this.user!.isDisabled;

        usersAApi.disableEnableUser(this.user!.id, newIsDisabled, data => {
            if (data.success) {
                this.user!.isDisabled = newIsDisabled;
            }

            this.isButtonsDisabled = false;
        }, errorMessage => {
            this.showError(errorMessage);

            this.isButtonsDisabled = false;
        })
    }

    async saveChanges() {
        this.isButtonsDisabled = true;

        let isValid = true;

        if (!await this.getGeneralAndContactInfoSection().validateAll()) {
            isValid = false;
        }

        if (this.isAdminWithUsersAccess && !await this.getUserAdminRightsSection().validateAll()) {
            isValid = false;
        }

        if (!await this.$validator.validateAll()) {
            isValid = false;
        }

        if (isValid) {
            usersAApi.updateUserEdit(this.user!, (data) => {
                if (data.success){
                    if (data.isAnyChanges) {
                        this.$bvToast.toast("Зміни успішно збережені", {
                            title: "Успіх",
                            variant: "success"
                        });
                    } else {
                        this.$bvToast.toast("Зміни не потрібні, інформація в актуальному стані", {
                            title: "Повідомлення",
                            variant: "info"
                        });
                    }
                } else {
                    this.showError()
                }


                this.isButtonsDisabled = false;
            }, errorMessage => {
                this.isButtonsDisabled = false;

                this.showError(errorMessage)
            });
        } else {
            this.isButtonsDisabled = false;
        }
    }
}
